 <div class="row wide-bg d-flex justify-content-center" [style.height]="'500px'" [style.background-image]="'url(' + this.bgImageUrl + ')'">
     <div class="col-sm-8" style="width: 400px;flex: none; padding: 0">
         <div class="m-content form-block">
             <div class="row">
                 <div class="col-lg-12 login-box">
                     <div>
                         <div>

                             <h1 class="accent-text login-page-title" >
                               {{'FORGOT_MY_USERNAME' | dictionary}}
                             </h1>
                         </div>
                         <div class="form-group text-center" >
                             <span class="small-note-text">{{'FORGOT_CRED_NOTE' | dictionary : 'username'}}
                             </span>
                         </div>
                         <div class="pt-0 pb-0" style="padding:0;">
                             <form class="login-block">
                                 <div class="m-portlet__body">
                                     <div class="form-group pb-3">

                                         <input [(ngModel)]="email"
                                             class="form-control home-login-input-text"
                                             name="username" aria-describedby="emailHelp" placeholder="{{'EMAIL_ADDRESS' | dictionary}}"
                                             (keyup.enter)="submit()">
                                     </div>
                                     <div class="form-group">
                                     </div>
                                     <div class="form-group text-center">
                                         <button (click)="submit()"
                                             class="button-1">
                                           {{'SEND_EMAIL'| dictionary}}
                                         </button>
                                         <button (click)="cancel()"
                                         class="ml-15 button-1">
                                           {{'CANCEL'| dictionary}}
                                     </button>
                                     </div>

                                 </div>
                             </form>
                         </div>
                     </div>

                 </div>
                 <div class="col-lg-3">
                 </div>
             </div>
         </div>
     </div>


     <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
     </app-pop-up-dialog>

     <p-dialog header="" [(visible)]="displaySuccessMessage" [modal]="true" [resizable]="false" [focusOnShow]="true"
               class="forgotpasswordemaillink" [draggable]="false" (onHide)="hidePopupAndNavigateHome()">
       <div class="dialog-wrapper">
         <div class="col-lg-12 text-center">
           <h3>{{'REQUEST_SENT' | dictionary}}</h3>
           <p>{{'YOU_SHOULD_RECEIVE_EMAIL' | dictionary : email}}</p>
                           <p style="margin-top: 15px;">{{'CHECK_SPAM_IF_YOU_DONT_RECEIVE_EMAIL' | dictionary : clientName}}
                           </p>
                           <p style="margin-top: 10px;">{{'IF_YOU_CONTINUE_TO_HAVE_PROBLEM' | dictionary : clientName : clientPhoneNumber }}
                           </p>
         </div>
       </div>
      <ng-template pTemplate="footer">
         <button class="button-1" type="button" (click)="hidePopupAndNavigateHome()">{{'CLOSE' | dictionary}}</button>
       </ng-template>
     </p-dialog>

 </div>
